export const JOB_STATUS_QUEUED = 'QUEUED';
export const JOB_STATUS_IN_PROGRESS = 'IN_PROGRESS';
export const JOB_STATUS_SUCCESS = 'SUCCESS';
export const JOB_STATUS_ERROR = 'ERROR';
export const JOB_STATUS_CANCELED = 'CANCELED';